import { useTranslation } from 'react-i18next';
import { Form, Row, Col, Divider } from 'antd';
import { CheckOutlined } from '@ant-design/icons';

import { Button, PageHeader } from '../../../../components';

import styles from './style.module.scss';
import { useSalesTracking } from '../useSalesTracking';
import FormSections from './formSections';
import { useCallback, useEffect, useState } from 'react';
import FormHelper from '../../../../helpers/FormHelper';
import { useSearchParams } from 'react-router-dom';

const Edit = ({ isNew }) => {
  const { t } = useTranslation();
  const [isAnonymous, setIsAnonymous] = useState(false);
  const [searchParams] = useSearchParams();
  const title = isNew
    ? t('CREARE SALES TRACKING').toUpperCase()
    : t('MODIFICA SALES TRACKING').toUpperCase();
  const {
    form,
    handleCreateOrUpdate,
    updateInProcess,
    shops,
    inactiveShops,
    countries,
    regions,
  } = useSalesTracking(false, true);

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onClickSave = () => {
    form.submit();
  };

  const onFinish = async (values) => {
    await handleCreateOrUpdate(values);
  };

  const onChangeType = useCallback((e) => {
    setIsAnonymous(e.target.checked);
  }, []);


  useEffect(() => {
    const currentParams = Object.fromEntries([...searchParams]);
    if (Object.keys(currentParams).length) {
      const values = [];
      Object.keys(currentParams).forEach(k => {
        values.push({
          name: k,
          value: currentParams[k],
        });
      });
      form.setFields(values);
    }
  }, [searchParams, form]);

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Form
          form={form}
          name='basic'
          wrapperCol={{
            span: 24,
          }}
          initialValues={{
            age: '30 - 40',
            sex: 'male',
            country: '',
            region: '',
            sales_trackings_type: false,
            amount: '',
            customer_code: '',
            company_id: null,
            by_infopoint: false,
            is_stock_picking: false,
            click_collect_order_id: null,
          }}
          onFieldsChange={(field) => {
            FormHelper.resetFormsFieldErrors(form)(field);
          }}
          layout={'vertical'}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
        >
          <FormSections
            countries={countries}
            regions={regions}
            shops={shops}
            inactiveShops={inactiveShops}
            isAnonymous={isAnonymous}
            onChangeType={onChangeType}
          />
        </Form>
        <Row>
          <Col span={24}>
            <Divider />
          </Col>
        </Row>
        <Row gutter={16}>
          <Col>
            <Button
              onClick={onClickSave}
              width={'150px'}
              big
              icon={<CheckOutlined />}
              loading={updateInProcess}
            >
              {t('Invia')}
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};
export default Edit;
